
namespace GeniuzPOS.Customer {

    @Serenity.Decorators.registerClass()
    export class CsCustomerGrid extends Serenity.EntityGrid<CsCustomerRow, any> {
        protected getColumnsKey() { return CsCustomerColumns.columnsKey; }
        protected getDialogType() { return CsCustomerDialog; }
        protected getIdProperty() { return CsCustomerRow.idProperty; }
        protected getInsertPermission() { return CsCustomerRow.insertPermission; }
        protected getLocalTextPrefix() { return CsCustomerRow.localTextPrefix; }
        protected getService() { return CsCustomerService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );   
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: CsCustomerService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));         
            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
    }
}